<script setup lang="ts">
type VerticalGaps = '0'|'1'|'2'|'3'|'4'|'5';

const {
    gapTop = '0',
    gapBottom = '0',
    spread = 'maximal',
    separator,
} = defineProps<{
    gapTop?: VerticalGaps,
    gapBottom?: VerticalGaps,
    avoidOuterGap?: boolean,
    spread?: false|'minimal'|'maximal',
    separator?: boolean,
}>();

if (separator && (gapTop === '0' && gapBottom === '0')) {
    console.warn('separator hat keine Auswirkung, wenn es keine Gap zwischen den Element gibt');
}
</script>

<template>
    <div
        :class="[
            $style.vertical_align_children_wrapper,
            spread ? $style['spread_' + spread] : '',
            gapTop !== '0' ? [$style.top, $style['top_gap_' + gapTop], avoidOuterGap === true ? $style.no_outer_gap : '', separator === true ? $style.separator : ''] : '',
            gapBottom !== '0' ? [$style.bottom, $style['bottom_gap_' + gapBottom], avoidOuterGap === true ? $style.no_outer_gap : '', separator === true ? $style.separator : ''] : '',
        ]"
    >
        <slot/>
    </div>
</template>

<style lang="scss" module>
@use '@borders' as *;

.vertical_align_children_wrapper {
    &.spread_minimal {
        flex-grow: 1;
    }
    &.spread_maximal {
        width: 100%;
    }
    > a {
        display: block;
    }
    &.top {
        &.separator {
            > * {
                position: relative;

                &::before {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    background-color: $default-line-color;
                }
            }
        }
        &.no_outer_gap {
            > *:first-child {
                margin-top: initial;
            }
            &.separator > *:first-child::before {
                display: none;
            }
        }
    }
    &.top_gap_1 {
        > * {
            margin-top: .5rem;
        }
        &.separator > *::before {
            top: -.25rem;
        }
    }
    &.top_gap_2 {
        > * {
            margin-top: 1rem;
        }
        &.separator > *::before {
            top: -.5rem;
        }
    }
    &.top_gap_3 {
        > * {
            margin-top: 2rem;
        }
        &.separator > *::before {
            top: -1rem;
        }
    }
    &.top_gap_4 {
        > * {
            margin-top: 3rem;
        }
        &.separator > *::before {
            top: -1.5rem;
        }
    }
    &.top_gap_5 {
        > * {
            margin-top: 4rem;
        }
        &.separator > *::before {
            top: -2rem;
        }
    }
    &.bottom {
        &.separator {
            > * {
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    background-color: $default-line-color;
                }
            }
        }
        &.no_outer_gap {
            > *:last-child {
                margin-bottom: initial;
            }
            &.separator > *:last-child::after {
                display: none;
            }
        }
    }
    &.bottom_gap_1 {
        > * {
            margin-bottom: .5rem;
        }
        &.separator > *::after {
            bottom: -.25rem;
        }
    }
    &.bottom_gap_2 {
        > * {
            margin-bottom: 1rem;
        }
        &.separator > *::after {
            bottom: -.5rem;
        }
    }
    &.bottom_gap_3 {
        > * {
            margin-bottom: 2rem;
        }
        &.separator > *::after {
            bottom: -1rem;
        }
    }
    &.bottom_gap_4 {
        > * {
            margin-bottom: 3rem;
        }
        &.separator > *::after {
            bottom: -1.5rem;
        }
    }
    &.bottom_gap_5 {
        > * {
            margin-bottom: 4rem;
        }

        &.separator > *::after {
            bottom: -2rem;
        }
    }
}
</style>
